module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-holder-box",
    style: ({
      'pointer-events': _vm.currentUser.free_trial_time <= 0 && !this.isSubscribed ? 'none' : ''
    })
  }, [_c('discover-nav', {
    class: _vm.show_nav ? 'navVisible' : 'navHide',
    attrs: {
      "pageName": "video",
      "disabled": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "invisible-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-container-main",
    on: {
      "mouseenter": function($event) {
        _vm.show_video_overlay = true;
        _vm.show_nav = true
      },
      "mouseleave": function($event) {
        _vm.hideOverlay();
        _vm.show_nav = false
      }
    }
  }, [_c('video', {
    ref: "myVideoPlayer",
    staticClass: "video-js vjs-default-skin vjs-fluid",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "id": "myVideoPlayer",
      "playsinline": _vm.onMobile,
      "disabled": true,
      "control": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-overlay",
    class: _vm.show_video_overlay ? 'visibleOverlay' : 'hideOverlay'
  }, [_c('div', {
    staticClass: "vo-content"
  }, [_c('h2', {
    staticClass: "vo-heading"
  }, [_vm._v("' " + _vm._s(_vm.video.name) + " '")]), _vm._v(" "), _c('div', {
    staticClass: "vo-following-main"
  }, [_c('div', {
    staticClass: "dflex align-center gap-10"
  }, [_c('div', {
    staticClass: "profile-img",
    style: ({
      'background-image': 'url(' + _vm.video.user.avatar.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-text"
  }, [_vm._v(_vm._s(_vm.video.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "following-btns"
  }, [(_vm.video.user.id !== _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.video.user,
      "type": "default",
      "borderRadius": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "icon-button",
    on: {
      "click": function($event) {
        _vm.addToCollection()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/plus.svg"),
      "width": "18"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "icon-button",
    on: {
      "click": function($event) {
        _vm.openShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "invert",
    attrs: {
      "src": require("../../../assets/respond-arrow 2.svg"),
      "width": "18"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "icon-button"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/line-chart.svg"),
      "width": "18"
    }
  })])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.assoc.assoc_type !== null && _vm.displayListingProduct) ? _c('div', {
    staticClass: "ad-d-bar"
  }, [_c('img', {
    attrs: {
      "src": _vm.assoc.itemPic,
      "width": "100%"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.displayListingProduct && _vm.assoc.assoc_type !== null) ? _c('div', {
    staticClass: "ad-show"
  }, [_c('div', {
    staticClass: "ad-show-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.assoc.itemPic,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-show-content"
  }, [_c('div', {
    staticClass: "dflex align-center gap-10"
  }, [_c('div', {
    staticClass: "profile-img",
    style: ({
      'background-image': 'url(' + _vm.assoc.userImageUrl + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-text"
  }, [_vm._v(_vm._s(_vm.assoc.username))])]), _vm._v(" "), _c('div', {
    staticClass: "ad-info my-3"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.assoc.category))]), _vm._v(" "), _c('div', {
    staticClass: "name my-1"
  }, [_vm._v(_vm._s(_vm.assoc.name))]), _vm._v(" "), (_vm.assoc.assoc_type === 'ShopProduct') ? _c('div', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.assoc.price))]) : _vm._e()]), _vm._v(" "), (_vm.assoc.assoc_type === 'ShopProduct') ? _c('div', {
    staticClass: "ad-option ad-d-btn mt-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.options(),
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Option"
    },
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  }), _vm._v(" "), (_vm.assoc.assoc_type === 'ShopProduct') ? _c('v-btn', {
    staticClass: "ad-btn",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.assoc.stock > 0 ? _vm.addToCart() : ''
      }
    }
  }, [(_vm.assoc.stock > 0) ? _c('span', [_vm._v("Add to cart")]) : _c('span', [_vm._v("Out of Stock")])]) : _vm._e()], 1) : _c('div', [_c('v-btn', {
    staticClass: "ad-btn",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('span', [_vm._v("Play Song")])])], 1)]), _vm._v(" "), _c('div')]) : _vm._e()]), _vm._v(" "), (_vm.currentUser && _vm.currentUser.creator_verified && _vm.video.user.stripe_connected && _vm.video.user.creator_verified && _vm.video.user.id !== _vm.currentUser.id) ? _c('li', [(_vm.showSendLoveModal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.video.user,
      "dismiss": _vm.dismissLoveDialog
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.video,
      "type": "Stream",
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showListeningMessage),
      callback: function($$v) {
        _vm.showListeningMessage = $$v
      },
      expression: "showListeningMessage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Still Listening")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you still Listening?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideListeningMessage($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), (this.user) ? _c('div', [_c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/project.svg"),
      "width": "25"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b940dcf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/video_player.vue
// module id = 1716
// module chunks = 180